import styled from "styled-components";

export const VideoContainer= styled.div`
  display: flex;
  justify-content: center;
`

export const VideoImg= styled.img`
  @media (max-width: 600px) {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
